module.exports = __webpack_public_path__ + "static/img/coupon0.cc564064.png";